// extracted by mini-css-extract-plugin
var _1 = "sZR_W";
var _2 = "umppz";
var _3 = "epMJw";
var _4 = "j6t1R";
var _5 = "vmaSZ";
export { _1 as "branding", _2 as "icon", _3 as "powered-by", _4 as "powered-by--light", _5 as "powered-by--small" }
